import React from 'react'

export interface ILabelItemProps {
  className?: string
  children?: React.ReactNode
}

const LabelItem: React.FC<ILabelItemProps> = (props) => {
  const { className, children } = props
  return (
    <span
      className={tw`
        text-f-text-secondary text-sm
        ${className}
      `}
    >
      {children}
    </span>
  )
}

export default LabelItem
